module.exports = [
  {
    title: 'Ремонт дизельной грузовой и спецтехники',
    info:
      'Современные грузовые траки и спецтехника почти на 90 процентов приводится в движение с помощью дизельных двигателей. Автосервис Автодизель выполнит диагностику, ремонт грузовых траков, погрузчиков, тракторов, сельхоз техники.',
    items: [
      {
        title: 'Ремонт грузовой дизельной техники',
        info: 'Отремонтируем грузовые автомобили:',
        list: [
          ' RENAULT (РЕНО), VOLVO (ВОЛЬВО)-(Америка), MERCEDES-BENZ TRUCK (Мерседес-Бенц трак), SCANIA (СКАНИЯ), DAF (ДАФ), MAN (МАН), IVECO (ИВЕКО), Hino (ХИНО), ShacMan (Шакман), HYUNDAI (Хундай), MACK (МАК), MITSUBISHI (МИТСУБИСИ), NISSAN (НИССАН), ISUZU (ИСУЗУ), VOLVO (ВОЛЬВО), FREIGHTLINER (Фредлайнер), CATERPILLAR (Катерпиллер), FORD (ФОРД), INTERNATIONAL (Интернационал), JCB (ДжиСиБи), FOTON (Фотон), FAW (ФАВ), HOWO (ХОВО), Dongfeng (Донг Фенг), Shaanxi (Шанк Си), BAW (БАВ), КАМАЗ, ГАЗ, ЗИЛ'
        ]
      },
      {
        title: 'Сельхоз и спецтехника',
        info: 'Ремонт дизельной сельхоз и спецтехники в Донецке',
        list: [
          'экскаваторов и погрузчиков VOLVO EW, EC, JCB, CASE, NEW HOLLAND, LIEBHERR, ATLAS, TEREX, KOMATSU, HITACHI',
          'тракторов MEDION 310, FORD CARGO 3530, HUNTER, FENDT 936, CASE 310, MASSEY FERGUSON 8480, NEW HOLLAND T8050, JOHN DEERE 7820, 8336, 8420, 8850,9320, 9430, ROPA'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/spectechnic.js